import {
  i
} from "./chunk.FAJKIEWS.js";

// src/components/icons/jb-close-icon/jb-close-icon.css.ts
var jb_close_icon_css_default = i`svg{cursor:pointer;display:inline-block;fill:rgb(var(--rgb-primary, 20, 30, 85));height:var(--icon-size, 29px);transform:scale(1);transition:transform .3s linear;width:var(--icon-size, 30px)}svg:hover{transform:scale3d(0.8, 0.8, 1);transition:transform .3s linear}@media(forced-colors: active){svg{fill:CanvasText}}`;

export {
  jb_close_icon_css_default
};
